import type { ManagedSession } from './managed-session.ts'
import { Timer } from '@core/timer/timer.ts'
import { SessionStore } from '../storage/session-storage-manager.ts'

/**
 * @internal
 */
export class TransientSession implements ManagedSession {
    private readonly timer: Timer

    public constructor(public readonly store: SessionStore) {
        this.timer = new Timer('session_timer', this._handleSessionTimerDidAdvance.bind(this), 1, { autoStart: false })
    }

    public _start() {
        if (this.timer.isStarted) {
            this.timer._unpause()
            return
        }

        this.timer._start()
    }

    public _stop() {
        this.timer._pause()
    }

    protected async _handleSessionTimerDidAdvance(): Promise<void> {
        const prevRuntimeSeconds = await this.store._getSessionRuntimeSeconds()
        await this.store._setSessionRuntimeSeconds(prevRuntimeSeconds + 1)
    }
}
